<template>
  <div class="qw-page-header">
    <div class="qw-page-header__left">
      <h1 class="qw-page-title">{{ title }}</h1>
      <el-breadcrumb v-if="showBreadcrumb" separator="/" class="qw-breadcrumb">
        <el-breadcrumb-item :to="{ path: '/userList' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-if="$slots.actions" class="qw-page-header__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
// 页面标题头：标题 + 面包屑 + 右侧操作区
// 视觉全部由全局 layout.scss / business-page-theme.scss 的 .qw-page-header 体系接管
export default {
    name: 'PageHeader',
    props: {
        title: { type: String, default: '' },
        showBreadcrumb: { type: Boolean, default: false }
    }
}
</script>
